import { default as Modal } from './AbstractModal';

export default class extends Modal {
    constructor(m) {
        super(m);

        this.shareBind = this.share.bind(this)

        this.$buttons = this.$('share')
    }

    /**
     * The CSS class name to apply to `<html>` to mark the modal as open.
     *
     * @var {string}
     */
    activeClass = 'has-share-open'

    share(e) {
        const el = e.target;
        const platform = this.getData('platform', e.target)
        const url = window.location.href
        let shareUrl;

        switch (platform) {
            case 'facebook':
                shareUrl = 'https://facebook.com/sharer/sharer.php?u=' + url;
                this.openWindow(shareUrl);
                break;

            case 'twitter':
                shareUrl = 'https://twitter.com/share?url=' + url +
                    '&amp;text=' + encodeURIComponent(this.getData('text', e.target))
                this.openWindow(shareUrl);
                break;

            case 'mail':
                const subject = encodeURIComponent(this.getData('subject', e.target))
                const body = encodeURIComponent(this.getData('body', e.target))
                this.openMail(subject, body);
                break;

            case 'linkedin':
                shareUrl = `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}`;
                this.openWindow(shareUrl);
                break;

            case 'copy':
                this.copyUrl(url);
                break;
        }
    }

    openWindow(url) {
        window.open(url, 'Share', 'menubar=no, toolbar=no, resizable=yes, scrollbars=yes, height=500, width=600');
    }

    openMail(subject, body) {
        window.location = 'mailto:?subject=' + subject + '&body=' + body;
    }

    copyUrl(url) {
        this.el.classList.add('has-copy-feedback')

        if (this.copyTimeout != undefined) {
            clearTimeout(this.copyTimeout);
        }

        this.copyTimeout = setTimeout(() => {
            this.el.classList.remove('has-copy-feedback')
        }, 1500)

        window.copyToClipboard(url)
    }

    bindEvents() {
        for (let index = 0; index < this.$buttons.length; index++) {
            const $button = this.$buttons[index];
            $button.addEventListener('click', this.shareBind)
        }
    }

    unbindEvents() {
        for (let index = 0; index < this.$buttons.length; index++) {
            const $button = this.$buttons[index];
            $button.removeEventListener('click', this.shareBind)
        }
    }

    onInit() {
        this.bindEvents()
    }

    onDestroy() {
        this.unbindEvents()
    }

}